var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from "react";
import classNames from "classnames";
import { Icon } from "../Icon";
import { Accordion } from "../Accordion";
// use the optional prop interface to define the default props
const defaultProps = {
    "data-testid": "tecma-drawerAccordion",
};
const DrawerAccordion = (_a) => {
    var { headerIcon, headerLabel, className, children } = _a, rest = __rest(_a, ["headerIcon", "headerLabel", "className", "children"]);
    const classList = classNames("tecma-drawerAccordion", className);
    const [isOpen, setIsOpen] = useState(-1);
    const handleClick = () => (isOpen === -1 ? setIsOpen(0) : setIsOpen(-1));
    return (_jsx(Accordion, { openPanels: isOpen, onClick: handleClick, className: classList, children: _jsx(Accordion.Content, Object.assign({ headerComponent: _jsxs(_Fragment, { children: [headerIcon && _jsx(Icon, { iconName: headerIcon, size: "medium" }), _jsx("span", { className: "header-label", children: headerLabel }), _jsx(Icon, { iconName: isOpen ? "chevron-down" : "chevron-up" })] }) }, rest, { children: children })) }));
};
DrawerAccordion.defaultProps = defaultProps;
export default React.memo(DrawerAccordion);
